import Delegate from "//legramme.com/cdn/shop/t/76/assets/ftdomdelegate.min.js?v=167457923630348017651764174054";
import FixFlickity from "//legramme.com/cdn/shop/t/76/assets/ftdomflickity-fix.js?v=95405438931270853161764174048";

export class ProductCarouselSection extends HTMLElement {
  connectedCallback() {

      this.allTabs          = this.querySelectorAll('[data-action="change-tab"]');
      this.allProductsTabs  = this.querySelectorAll('[data-action="products-tab"]');
      this.infosVideo       = this.querySelectorAll('.product-carousel-section__video');
      this.sliderLeave      = this.querySelectorAll('[data-action="toggle-scroll-origin"]');

      this._attachListeners();
      this._themeEditorSettings();
      this._initVideo();

      let that = this;
      Pace.on('done', function() {
        that._initSliders();
      });

      new FixFlickity();

      this.sliderLeave.forEach(function(value, index) {
        value.onmouseleave = function() { 
          that._toggleScrollOrigin(value);
        }
      });

    }
  
    _attachListeners() {
      new Delegate(this).on('click', '[data-action="change-tab"]', this._changeTab.bind(this));
      new Delegate(this).on('mouseover', '[data-action="toggle-scroll-images"]', this._toggleScrollImages.bind(this));
      new Delegate(this).on('click', '[data-action="toggle-group"]', this._toggleGroup.bind(this));
      new Delegate(this).on('click', '[data-action="toggle-group-overlay"]', this._toggleGroupOverlay.bind(this));
      window.addEventListener('resize', this._initSliders.bind(this));
    }
    
  
    _changeTab(event, target) {
      event.preventDefault();

      /** slider destroy */
      if (this.sliders) {
        for (let i = 0; i < this.sliders.length; i++) {
          this.sliders[i].destroy();
        }
      }
  
      if (this.allTabs && this.allProductsTabs) {
        for (let i = 0; i < this.allTabs.length; i++) {
          this.allTabs[i].classList.remove('active');
          this.allProductsTabs[i].classList.remove('active');
        }
      }
  
      target.classList.add('active');
      if (this.querySelector('[data-action="products-tab"][data-tab="'+target.getAttribute('data-tab')+'"]')) {
        this.querySelector('[data-action="products-tab"][data-tab="'+target.getAttribute('data-tab')+'"]').classList.add('active');
      }
      
      
      /** slider initialisation tab active */
      this._initSliders();
    }

    _themeEditorSettings() {
  
      let that = this;
      $(document).on('shopify:block:select', '[data-action="change-tab"]', function (e){
        that._changeTab(e, e.target);
      });
    }

      /**
     * INIT VIDEO FROM IFRAME
     */
    _initVideo() {
      this.infosVideo.forEach(function(value, index) {
        value.setAttribute('src', value.getAttribute('data-src'));
      });
    }

  /**
   * Init Sliders
   */

   _initSliders() {
      //fix Flickity slider

      this.sliders = [];

      let sliders       = this.querySelectorAll('.product-carousel-section__content-container.active .dots .product__images-slider');
      let sliderOptions = {
        prevNextButtons: false,
        wrapAround: true,
        pageDots: true,
        draggable: true,
      }

      if (window.matchMedia("(min-width: 1024px)").matches) {
        sliderOptions["draggable"] = false;
        sliderOptions["fade"] = true;
      }
      
      if (sliders.length > 0) {
        for (let i = 0; i < sliders.length; i++) {
          this.sliders[i] = new Flickity(sliders[i], sliderOptions);
          this.sliders[i].on( 'dragStart', function( event, pointer ) {
            this.element.classList.add('text_disappear');
          });
          this.sliders[i].on( 'dragEnd', function( event, pointer ) {
              this.element.classList.remove('text_disappear');
          });
        }
      }
      if (window.matchMedia("(min-width: 1024px)").matches) {
        let widthSliderContainer   = window.innerWidth / 4 ;
        let heightSliderContainer  = (widthSliderContainer / 4 ) * 5;

        let sliderContainer       = this.querySelectorAll('.product-carousel-section__content-container.active .product-carousel-section__products .product__images-slider-container');
        let heightContainer       = this.querySelector('.product-carousel-section__content-container.active.blocs .bloc__height');

        if (heightContainer) {
          sliderContainer.forEach(function (item){
            item.style.height = heightSliderContainer + 'px';
          });

          heightContainer.style.height = (heightSliderContainer * 2) + 'px';
        }
      } else {

        let sliderContainer       = this.querySelectorAll('.product-carousel-section__content-container.active .product-carousel-section__products .product__images-slider-container');
        let heightContainer       = this.querySelector('.product-carousel-section__content-container.active.blocs .bloc__height');

        if (sliderContainer) {
          sliderContainer.forEach(function (item){
            item.style.height = 'inherit';
          });
        }
        if (heightContainer) {
          heightContainer.style.height = 'inherit';
        }
      }


    }

    /**
   * PRODUCT IMAGE SCROLL
   */

     _toggleScrollImages(event, target) {

      let index = target.getAttribute('data-index');
      let indexSlider = target.getAttribute('data-slider');

      this.querySelectorAll('[data-slider="'+indexSlider+'"]').forEach(function(value) {
        value.classList.remove('active');
      })
      target.classList.add('active');

      if (this.sliders[indexSlider]) {
        this.sliders[indexSlider].select(index, true, false)
      }

    }

    _toggleScrollOrigin(target){

      let index = 0;
      let indexSlider = target.getAttribute('data-slider');
  
      target.querySelectorAll('[data-slider="'+indexSlider+'"]').forEach(function(value) {
        value.classList.remove('active');
      })
      target.querySelector('[data-index="'+index+'"]').classList.add('active');
  
      if (this.sliders[indexSlider]) {
        this.sliders[indexSlider].select(index, true, false)
      }
    }

    _toggleGroup(event, target) {

      if (event) event.preventDefault();

      let index = target.getAttribute('data-index');

      this.groupPopin       = this.querySelector('[data-element="group_'+index+'"]');
      this.groupOverlay     = this.querySelector('[data-element="group-overlay"]');
  
      if (this.groupPopin.classList.contains('active')) {
        document.querySelector('body').classList.remove('no-scroll');
        this.groupPopin.classList.remove('active');
        this.groupOverlay.classList.remove('active');
      } else {
        document.querySelector('body').classList.add('no-scroll');
        this.groupPopin.classList.add('active');
        this.groupOverlay.classList.add('active');
      }
  
    }

    _toggleGroupOverlay(event, target) {

     

      this.groupPopins       = this.querySelectorAll('[data-section-type="group-section"]');
      this.groupOverlay     = this.querySelector('[data-element="group-overlay"]');
  

      this.querySelectorAll('[data-section-type="group-section"]').forEach(function(value) {
        value.classList.remove('active');
      })

      this.groupOverlay.classList.remove('active');
      document.querySelector('body').classList.remove('no-scroll');

    }
        
  
}
try {
  window.customElements.define('product-carousel-section', ProductCarouselSection);
} catch(e) {}